<template>
  <b-img
    :src="$store.state.app.logoSRC"
    :alt="$t($store.state.app.title)"
    :width="width"
  />
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  name: 'LogoImg',
  components: {
    BImg,
  },
  computed: {
    width() {
      return this.$store.state.app.logoSize.width > 150 ? 150 : this.$store.state.app.logoSize.width
    },
  },
}
</script>

<style scoped>

</style>
